import { API, graphqlOperation } from "aws-amplify";

import { getJobOpportunityQuery } from "./graphql/queries";

const getJobOpportunity = (id) =>
  API.graphql(graphqlOperation(getJobOpportunityQuery, { id }));

export default getJobOpportunity;
